import Table from 'src/javascripts/components/Table';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import {genericDisplayTemplate, logoTemplate, noResultsTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import Swal from 'sweetalert2';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default function() {
  const accountUrl = $('body').attr('data-account-url');

  // Set function for confirming leaving without saved changes
  const confirmLeave = function(e, href) {
    e.preventDefault();

    // Confirm and then continue with request
    return Swal.fire({
      title: "You have unsaved changes",
      text: "Are you sure you want to leave? You have unsaved changes that have not been applied.",
      animation: false,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Continue anyway',
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-light border',
        popup: 'animated fadeIn faster'
      }
    }).then((result) => {
      if (result.value) {
        Turbo.visit(href);
      }
    });

  }

  // Add spinner and opacity
  Spinner($('#portfolioAssetsCard'));
  $('#portfolio_model_investments_body').css('opacity', 0.25);

  // On save add spinners, opacity
  $('.save-portfolio-model').click(function(e) {

    // Submit form if name present
    let nameField = $('#reusableModelNameInput')
    if (nameField.length > 0) {

      let name = nameField.val();
      if (name.length > 0) {

        // Submit form
        Spinner($('#portfolioAssetsCard'));
        $('#portfolio_model_investments_body').css('opacity', 0.25);
        Spinner($('#researchResultsCard'));
        $('#researchResultsCard .card-body').css('opacity', 0.25);
        $(this).tooltip('hide');

      } else {

        e.preventDefault();
        ToastCustom({title: 'Name required', message: 'Please enter a name for the model', delay: 3000});
        setTimeout(function() {
          nameField.focus();
        }, 500);
      }

    } else {

      // Not a model, so don't require name
      Spinner($('#portfolioAssetsCard'));
      $('#portfolio_model_investments_body').css('opacity', 0.25);
      Spinner($('#researchResultsCard'));
      $('#researchResultsCard .card-body').css('opacity', 0.25);
      $(this).tooltip('hide');

    }

  });

  // On update benchmark filter
  $('.benchmark-filter').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
    $('#reusableModelBenchmarkInput').val(suggestion.fund_id);
  });

  // On selecting a fund as benchmark
  $('.clear-typeahead').click(function() {
    let t = $(this).closest('.form-group').find('.typeahead');
    t.typeahead('val', '');
    t.focus();
  })

  // Init portfolio models and lists bloodhound
  const modelsBloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: '/' + accountUrl + '/portfolios/models?order_col=portfolio_models.name&query=%QUERY',
      wildcard: "%QUERY",
      transform: function(d) { return d.data; }
    }
  });
  modelsBloodhound.initialize();

  const listsBloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: '/' + accountUrl + '/lists?query=%QUERY',
      wildcard: "%QUERY",
      transform: function(d) { return d.data; }
    }
  });
  listsBloodhound.initialize();

  // Initiate apply models typeahead
  $('.apply-model-typeahead').typeahead({
    hint: true,
    highlight: true,
    minLength: 0,
  }, {
    name: 'models',
    display: 'name',
    limit: 754,
    source: modelsBloodhound.ttAdapter(),
    templates: {
      suggestion(el) {
        if (el.name === null) {
          return noResultsTemplate();
        } else {
          return genericDisplayTemplate(el.name);
        }
      }
    },
  });

  // Initiate apply list typeahead
  $('.apply-list-typeahead').typeahead({
    hint: true,
    highlight: true,
    minLength: 0,
  }, {
    name: 'lists',
    display: 'name',
    limit: 754,
    source: listsBloodhound.ttAdapter(),
    templates: {
      suggestion(el) {
        if (el.name === null) {
          return noResultsTemplate();
        } else {
          return genericDisplayTemplate(el.name);
        }
      }
    },
  });

  // Reblance weights to 100%
  $('.rebalance-portfolio-model').click(function(ev) {

    // Prevent default
    ev.preventDefault();

    // If portfolio is present, double check that
    // user wants to update underlying model
    // Hide tooltip
    $(this).tooltip('hide');

    // Add spinner and opacity to table
    Spinner($('#portfolioAssetsCard'));
    $('#portfolio_model_investments_body').css('opacity', 0.25);

    // Build ajax call to add/remove selection from model filters
    let modelId = $(this).attr('data-model-id');
    let params = {};
    params['portfolio_model_filter'] = {}
    params['portfolio_model_filter']['model_id'] = modelId;
    if (typeof portfolioId !== 'undefined') {params['portfolio_id'] = portfolioId;}
    params['scope'] = $(this).attr('data-scope');
    let url = '/' + accountUrl + '/portfolios/models/' + modelId + '/rebalance.json?' + $.param(params);

    // Create a filter for model
    $.ajax({
      type: 'PATCH',
      url: url,
      dataType: 'application/json',
      complete(result) { 
        let investmentsCount = JSON.parse(result.responseText).investments_count;
        let investmentsWeight = JSON.parse(result.responseText).investments_weight;

        // Reload table data
        $('#portfolio_model_investments_table').DataTable().ajax.reload();

        // Re-enable typeaheads and add filters
        $('.model-interaction').removeClass('disabled');

        // Set unsaved changes to true
        $('.save-portfolio-model').attr('data-unsaved-changes', true);

        // Update totals
        $('#investmentsCount').empty().append(investmentsCount);
        $('#investmentsWeight').empty().append(investmentsWeight);

      },
    });
  });

  // Apply an existing model on typeahead select
  $('.apply-model-typeahead').bind('typeahead:beforeselect', function(ev, suggestion) {

    // Prevent default
    ev.preventDefault();

    // Return if has class disabled
    if ($(this).hasClass('disabled')) {return;}

    // Temporarily disable typeahead and add filter buttons
    $('.model-interaction').addClass('disabled');

    // Add spinner and opacity to table
    Spinner($('#portfolioAssetsCard'));
    $('#portfolio_model_investments_body').css('opacity', 0.25);

    // Build ajax call to add/remove selection from model filters
    let modelId = $(this).attr('data-model-id');
    let portfolioId = $(this).attr('data-portfolio-id');
    let params = {};
    params['portfolio_id'] = portfolioId;
    params['model_to_dup_id'] = suggestion.record_id;
    let url = '/' + accountUrl + '/portfolios/models/' + modelId + '/dup_existing.json?' + $.param(params);

    // Create a filter for model
    $.ajax({
      type: 'PATCH',
      url: url,
      dataType: 'application/json',
      complete(result) { 
        // Reload page
        Turbo.visit("/" + accountUrl + "/portfolios/models/" + modelId + "/edit?portfolio_id=" + portfolioId + "&uc=true&notice=Added " + suggestion.name + ". Click 'Save' to save the model");
      },
    });

  });

  // Apply an existing model on typeahead select
  $('.apply-list-typeahead').bind('typeahead:beforeselect', function(ev, suggestion) {

    // Prevent default
    ev.preventDefault();

    // Return if has class disabled
    if ($(this).hasClass('disabled')) {return;}

    // Temporarily disable typeahead and add filter buttons
    $('.model-interaction').addClass('disabled');

    // Add spinner and opacity to table
    Spinner($('#portfolioAssetsCard'));
    $('#portfolio_model_investments_body').css('opacity', 0.25);

    // Build ajax call to add/remove selection from model filters
    let modelId = $(this).attr('data-model-id');
    let params = {};
    params['list_to_dup_id'] = suggestion.record_id;
    let url = '/' + accountUrl + '/portfolios/models/' + modelId + '/dup_existing.json?' + $.param(params);

    // Create a filter for model
    $.ajax({
      type: 'PATCH',
      url: url,
      dataType: 'application/json',
      complete(result) { 
        // Reload page
        Turbo.visit("/" + accountUrl + "/portfolios/models/" + modelId + "/edit?" + "uc=true&notice=Added " + suggestion.name + ". Click 'Save' to save the model");
      },
    });

  });

  // Start import status poll if importing
  let importPoll = () => {

    // Get generating message on page
    let isGenerating = $('.generating-message');

    // Only continue if status indicator present (if should poll for recs is true)
    if (isGenerating.length !== 0) {

      // Set Api url to get data
      let accountUrl = isGenerating.attr('data-account-url');
      let portfolioId = isGenerating.attr('data-portfolio-id');
      let modelId = isGenerating.attr('data-model-id');
      let url = '/' + accountUrl + '/portfolios/' + portfolioId + '/models/' + modelId + '/imports/check_import_status.js?';

      // Execute ajax request (using js erb template to render content so can control profile styling more easily)
      // Must specify '.js' otherwise processes as JSON
      $.ajax({
        type: "POST",
        dataType: "script",
        timeout: 3000,
        url: url,
        complete() {
          setTimeout(function() { importPoll() }, 4000);
        }
      });
    }
  };

  // Poll server for status of mapped items, if generating message present
  if ($('.generating-message').length !== 0) { importPoll(); }

}